<div class="profile-wrapper {{scalingClass}}">
  <div class="d-flex justify-content-end" *ngIf="_sharedService.rbacManagement('vehicles_Enrolled_DateTimeRangePicker')">
    <div class="widget-edit pdt-5 calender-pop-scroll report-date-field home-datetime-range">
        <form [formGroup]="datepickerForm">
          <app-datetime-range class="" formControlName="thisdate" [isDisabled]="false" [label]="'Date Range'" [autoApply]="false"
            [showCancel]="true" [timePicker]="true" [timePicker24Hour]="true" [timePickerSeconds]="true"
            [showCustomRangeLabel]="true" [alwaysShowCalendars]="true" [keepCalendarOpeningWithRange]="true" 
            [opens]="'left'" (datePassed)="saveTime($event)">
          </app-datetime-range>
        </form>
    </div>
  </div>
  <!-- Top parent wrapper tile  //start -->
  <div class="make-responsive-vehicleprofile top-wrapper" *ngIf="!toggleDigitalTwin"
    [ngClass]="{'cnp-monotainer': masterEntitiesData?.category === 'monotainer'}">
    <!-- entity Details (tile 1)  //start -->
    <app-entities-details [entityDetails]="masterEntitiesData" [entitiesStatus]="entitiesStatus" class="d-flex" (checkPointExpand)="checkPointExpand($event)" 
      [fromDate]="selectedDates.from" [toDate]="selectedDates.to">
    </app-entities-details>
    <!-- entity Details (tile 1)  //end -->
    <div class="second-level-container h-100" 
      [ngClass]="{'mono-second-level': masterEntitiesData?.category === 'monotainer'}">
      <div>
        <!-- top attribute list and alert (tile 2) //start -->
        <app-entities-top-attributes [entityDetails]="masterEntitiesData" [config]="attributeIcons"
          [refreshRate]="tenantConfig?.profileRefreshRate?tenantConfig?.profileRefreshRate:30000" [fromDate]="selectedDates.from" [toDate]="selectedDates.to">
        </app-entities-top-attributes>
        <!-- top attribute list and alert (tile 2) //end -->
      </div>
      <!-- widgets list and control (tile 3)//start -->
      <app-entities-widgets-listing [entityId]="entityId" [masterEntitiesData]="masterEntitiesData" [siteId]="siteId"
        [attributeThreshold]="attributeThreshold" [widgetDetails]="widgetDetails" [loader]="isLoader"
        [fromDate]="selectedDates.from" [toDate]="selectedDates.to">
      </app-entities-widgets-listing>
      <!-- widgets list and control (tile 3)//end -->
    </div>
  </div>
  <!-- unity 3D -->
  <div class="d-flex background-fill" *ngIf="toggleDigitalTwin">
    <app-digital-twin></app-digital-twin>
  </div>
  <!-- Top parent wrapper tile  //end -->
  <!-- Bottom parent wrapper tile  //start -->
  <div class="tab-container" [ngClass]="{'z-index-2': expandCheckPointFlag}">
    <!-- Tab Container //start -->
    <!-- <app-entities-tabs [tabData]="masterEntitiesData" [config]="attributeThreshold" [tenantType]="tenantType"
      [refreshRate]="refreshRate" (periodFilter)="periodFilter($event)">
    </app-entities-tabs> -->
    <app-tab-landing *ngIf="masterEntitiesData?objectKeys(masterEntitiesData)?.length:false"
      [tabData]="masterEntitiesData" [config]="attributeThreshold" [tenantType]="tenantType"
      [refreshRate]="tenantConfig?.profileRefreshRate?tenantConfig?.profileRefreshRate:30000"
      (periodFilter)="periodFilter($event)" [fromDate]="selectedDates.from" [toDate]="selectedDates.to"></app-tab-landing>
    <!-- Tab Container //end -->
  </div>
  <!-- Bottom parent wrapper tile  //end -->
</div>